// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__ptcf5","standard":"Button_standard__3N4Ma"};